import React, { useState } from 'react';
import { Col, Card, CardBody } from 'reactstrap';
import Rating from 'react-rating';
import HeaderCard from '../../Common/HeaderCard';

const SquareNumber = () => {
  const [rating, setRating] = useState(2);
  return (
    <Col xl='6' lg='12' md='6'>
      <Card>
        <HeaderCard title={'Square Rating'} />
        <CardBody>
          <div className='rating '>
            <Rating
              initialRating={rating}
              emptySymbol={[1, 2, 3, 4, 5].map((n) => (
                <span className='square-number'>{n}</span>
              ))}
              fullSymbol={[1, 2, 3, 4, 5].map((n) => (
                <span className='square-number active'>{n}</span>
              ))}
              onChange={(rate) => setRating(rate)}></Rating>
            <span className='current-rating'>{rating}</span>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default SquareNumber;
